var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarsSparkle = function SvgStarsSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2a2.667 2.667 0 0 1-2.667 2.667A2.667 2.667 0 0 1 4.5 7.333a2.667 2.667 0 0 1 2.667-2.666A2.667 2.667 0 0 1 4.5 2ZM11.833 10A3.333 3.333 0 0 0 8.5 6.667a3.333 3.333 0 0 0 3.333-3.333 3.333 3.333 0 0 0 3.334 3.333A3.334 3.334 0 0 0 11.833 10Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 10v.667M11.833 3.333v-.667M7.167 14v.667M7.167 9.333v-.667M4.5 7.333V8M4.5 1.333V2",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.167 9A2.667 2.667 0 0 1 4.5 11.667a2.667 2.667 0 0 1 2.667 2.666 2.667 2.667 0 0 1 2.666-2.666A2.667 2.667 0 0 1 7.167 9Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgStarsSparkle;